import { render, staticRenderFns } from "./InfiniteAfterDisposalItemCategoryAutoComplete.vue?vue&type=template&id=604ba974&scoped=true&"
import script from "./InfiniteAfterDisposalItemCategoryAutoComplete.vue?vue&type=script&lang=js&"
export * from "./InfiniteAfterDisposalItemCategoryAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ba974",
  null
  
)

export default component.exports